module.exports = __webpack_public_path__ + "static/kaller-9c1fcec20c6864d46bb3f55d4c4c925e.png";